// https://vuex.vuejs.org/en/getters.html

export default {
  getAppState: (state) => state.appState,
  getIsLoggedIn: (state) => state.isLoggedIn,
  getShowChat: (state) => state.showChat,
  getPaymentStep: (state) => state.paymentStep
};
